<template>
    <div class="menu" id="menu" v-outside-click>
        <div class="menu__logo">
            <img src="@/assets/menu.png" alt="logo.png">
        </div>
        <div class="menu__links">
            <div class="menu__link"
                @click="clickLink('/')"
            >
                Главная
            </div>
            <div class="menu__link"
                @click="clickLink('/personal-data')"
            >
                Обработка перс. данных
            </div>
            <div class="menu__link"
                @click="clickLink('/return-policy')"
            >
                Правила заказа и возврата
            </div>
          <div class="menu__link"
               @click="clickLink('/offer')"
          >
            Оферта
          </div>
        </div>
        <div class="menu__phone">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.62 7.79C5.06 10.62 7.38 12.94 10.21 14.38L12.41 12.18C12.69 11.9 13.08 11.82 13.43 11.93C14.55 12.3 15.75 12.5 17 12.5C17.2652 12.5 17.5196 12.6054 17.7071 12.7929C17.8946 12.9804 18 13.2348 18 13.5V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C12.4913 18 8.1673 16.2089 4.97918 13.0208C1.79107 9.8327 0 5.50868 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H4.5C4.76522 0 5.01957 0.105357 5.20711 0.292893C5.39464 0.48043 5.5 0.734784 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z" fill="white"/>
            </svg>
            <div class="menu__phone-text">
                8 800 900-90-70
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'idLogoMenu'
        ],
        methods: {
            async clickLink(link) {
                await this.$emit('clickLink')
                this.$router.push(link).catch(()=>{})
            },
            async clickClose() {
                this.$emit('clickClose')
            }
        },
        directives: {
            outsideClick: {
                inserted: (el, binding, vnode) => {
                    document.addEventListener('click', (event) => {
                        let id = document.getElementById(vnode.context.idLogoMenu)
                        if (!el.contains(event.target) && !id.contains(event.target)) {
                            vnode.context.$emit('clickOutside')
                        };
                    });
                }
            }
        }
    }
</script>

<style lang="less">
    .menu {
        top: 0px;
        right: 0px;
        width: 300px;
        background-color: #272340;
        height: 100%;
        min-height: 450px;
        position: fixed;
        z-index: 12;
        display: flex;
        flex-direction: column;
    }

    .menu__logo {
        width: 70px;
        height: 70px;
        margin-top: 20px;
        margin-left: 20px;
    }

    .menu__logo img {
        width: 100%;
        height: 100%;
    }

    .menu__links {
        text-transform: uppercase;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .menu__link {
        margin-top: 28px;
        color: white;
        font-size: 15px;
        line-height: 18px;
        font-family: 'Montserrat-Medium';
        font-style: normal;
        font-weight: 500;
        cursor: pointer;
        text-align: start;
    }

    .menu_button {
        position: absolute;
        top: 6px;
        right: 15px;
        cursor: pointer;
    }

    .menu__phone {
        height: 74px;
        width: 100%;
        background-color: #393952;
        align-items: center;
        display: flex;
        padding-left: 23px;
        position: absolute;
        bottom: 0px;
    }

    .menu__phone-text {
        color: #FFFFFF;
        text-transform: uppercase;
        font-size: 20px;
        font-family: 'Montserrat-Medium';
        margin-left: 13px;
    }

</style>